import { Alert, Snackbar } from '@mui/material';
import React from 'react';

const Alerton = ({ message, handleCloseMessage }) => {
  const vertical = 'top';
  const horizontal = 'center';
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={message !== ''}
      autoHideDuration={6000}
      onClose={handleCloseMessage}
    >
      <Alert
        onClose={handleCloseMessage}
        severity='error'
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Alerton;
